import React from 'react'
import PropTypes from 'prop-types'
import styles from './SearchToggle.css'
import Svg from "../Svg/Svg"
import {Icon, LIB} from "../../constants/consts-types"

const SearchToggle = props => (
  <button
    aria-label={LIB.search}
    className={styles.SearchToggle}
    onClick={props.onSearchToggle}
  >
    <Svg id={Icon.SEARCH} className={styles.icon}/>
  </button>
)

SearchToggle.propTypes = {
  onSearchToggle: PropTypes.func.isRequired
}

export default SearchToggle



// WEBPACK FOOTER //
// ./src/components/SearchToggle/SearchToggle.js